import { css } from 'linaria';
import * as Regions from 'common/constants/region-codes';
import { SeasonStartCategoryStructure } from './components/season-start-category';

export const SEASON_START_PATH = '/promo/na-start-vnimanie-dacha/';

export const SEASON_START_ELEMENT_BLOCK = 'landingStartSezona';

export const SEASON_START_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/season-start';

export const SEASON_START_LANDING_NAME = 'season-start';

export const SEASON_START_SOLUTIONS = [
  {
    link: {
      href: '/promo/pora-pora-stroitelstvo/',
      title: 'Поможем построить',
    },
    img: {
      alt: 'Баннер Поможем построить',
      srcD: `${SEASON_START_CDN_PATH}/banners/construction-banner-ld.jpg/construction-banner-ld-01.jpg`,
      srcT: `${SEASON_START_CDN_PATH}/banners/construction-banner-t.jpg/construction-banner-t-01.jpg`,
      src: `${SEASON_START_CDN_PATH}/banners/construction-banner-m.jpg/construction-banner-m-01.jpg`,
    }
  },
  {
    link: {
      href: '/promo/pora-pora-dom/',
      title: 'Обустроим дом',
    },
    img: {
      alt: 'Баннер Обустроим дом',
      srcD: `${SEASON_START_CDN_PATH}/banners/house-banner-ld.jpg/house-banner-ld.jpg`,
      srcT: `${SEASON_START_CDN_PATH}/banners/house-banner-t.jpg/house-banner-t.jpg`,
      src: `${SEASON_START_CDN_PATH}/banners/house-banner-m.jpg/house-banner-m.jpg`,
    }
  }
];

export const REGION_ID_LIST_WITHOUT_FENCES = [
  Regions.KAZAKHSTAN,
  Regions.VLADIKAVKAZ,
  Regions.VOLGOGRAD,
  Regions.IZHEVSK,
  Regions.KALININGRAD,
  Regions.KEMEROVO,
  Regions.KOSTROMA,
  Regions.KRASNODAR,
  Regions.KURSK,
  Regions.LIPETSK,
  Regions.MAGNITOGORSK,
  Regions.NOVOKUZNETSK,
  Regions.OMSK,
  Regions.ROSTOV_NA_DONU,
  Regions.SMOLENSK,
  Regions.STAVROPOL,
  Regions.CHEREPOVETS,
];

export const FENCES_CATEGORY = {
  href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/',
  img: {
    alt: 'Изображение забора из штакетника',
    src: `${SEASON_START_CDN_PATH}/categories/fences.jpg/fences.jpg`,
  },
  title: 'Заборы на заказ',
};

export const SEASON_START_SOLUTIONS_CATEGORIES: SeasonStartCategoryStructure[] = [
  {
    title: 'Отдохните\nна природе',
    img: {
      className: css`
        @media (--from-tablet) {
          height: 775px;
        }

        @media (--only-mobile) {
          height: 316px;
        }
      `,
      srcLd: `${SEASON_START_CDN_PATH}/categories/nature-bg-ld.jpg/nature-bg-ld.jpg`,
      srcD: `${SEASON_START_CDN_PATH}/categories/nature-bg-d.jpg/nature-bg-d.jpg`,
      srcT: `${SEASON_START_CDN_PATH}/categories/nature-bg-t.jpg/nature-bg-t.jpg`,
      src: `${SEASON_START_CDN_PATH}/categories/nature-bg-m.jpg/nature-bg-m-01.jpg`,
    },
    itemList: [
      {
        href: '/offer/tovary-dlya-dachi/grili-i-mangaly/',
        img: {
          alt: 'Изображение гриля',
          src: `${SEASON_START_CDN_PATH}/categories/grill.jpg/grill.jpg`,
        },
        title: 'Грили и мангалы',
      },
      {
        href: '/offer/tovary-dlya-dachi/mebel-dlya-sada/',
        img: {
          alt: 'Изображение садовой мебели',
          src: `${SEASON_START_CDN_PATH}/categories/garden-furniture.jpg/garden-furniture.jpg`,
        },
        title: 'Мебель для сада',
      },
    ]
  },
  {
    title: 'Создайте\nучасток мечты',
    textColor: 'text-invert',
    img: {
      className: css`
        @media (--from-tablet) {
          height: 775px;
        }

        @media (--only-mobile) {
          height: 484px;
        }
      `,
      srcLd: `${SEASON_START_CDN_PATH}/categories/plot-bg-ld.jpg/plot-bg-ld.jpg`,
      srcD: `${SEASON_START_CDN_PATH}/categories/plot-bg-d.jpg/plot-bg-d.jpg`,
      srcT: `${SEASON_START_CDN_PATH}/categories/plot-bg-t.jpg/plot-bg-t.jpg`,
      src: `${SEASON_START_CDN_PATH}/categories/plot-bg-m.jpg/plot-bg-m.jpg`,
    },
    itemList: [
      {
        href: '/offer/tovary-dlya-dachi/uhod-za-sadom/',
        img: {
          alt: 'Изображение садового инструмента',
          src: `${SEASON_START_CDN_PATH}/categories/garden-maintenance.jpg/garden-maintenance-03.jpg`,
        },
        title: 'Уход за садом',
      },
      {
        href: '/offer/tovary-dlya-dachi/obustroystvo-uchastka/',
        img: {
          alt: 'Изображение садового инвенторя',
          src: `${SEASON_START_CDN_PATH}/categories/site-development.jpg/site-development.jpg`,
        },
        title: 'Обустройство участка',
      },
      {
        href: '/offer/tovary-dlya-dachi/tehnika-dlya-sada/',
        img: {
          alt: 'Изображение газонокосилки',
          src: `${SEASON_START_CDN_PATH}/categories/garden-equipment.jpg/garden-equipment.jpg`,
        },
        title: 'Техника для сада',
      },
    ]
  },
];
